function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".deletea{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2121.167 -680.745)"
}, /*#__PURE__*/React.createElement("path", {
  className: "deletea",
  d: "M2137.125,683.427h-3.345v-.22a2.464,2.464,0,0,0-2.461-2.461h-3.71a2.45,2.45,0,0,0-2.452,2.343.862.862,0,0,0-.009.118v.22H2121.8a.637.637,0,0,0,0,1.273h1.371v11.407a2.464,2.464,0,0,0,2.461,2.461h7.658a2.45,2.45,0,0,0,2.452-2.343.9.9,0,0,0,.009-.118V684.7h1.371a.637.637,0,0,0,0-1.273Zm-10.7-.189c0-.025.005-.05.007-.077a1.182,1.182,0,0,1,1.181-1.142h3.71a1.189,1.189,0,0,1,1.188,1.188v.22h-6.086Zm8.06,12.838c0,.024-.006.05-.007.077a1.182,1.182,0,0,1-1.181,1.142h-7.658a1.189,1.189,0,0,1-1.188-1.188V684.7h10.033Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "deletea",
  d: "M2144.4,718.654a.637.637,0,0,0,.637-.637v-6.862a.637.637,0,0,0-1.273,0v6.862A.636.636,0,0,0,2144.4,718.654Z",
  transform: "translate(-17.8 -23.457)"
}), /*#__PURE__*/React.createElement("path", {
  className: "deletea",
  d: "M2157.908,718.654a.636.636,0,0,0,.636-.637v-6.862a.636.636,0,1,0-1.273,0v6.862A.636.636,0,0,0,2157.908,718.654Z",
  transform: "translate(-28.444 -23.457)"
}), /*#__PURE__*/React.createElement("path", {
  className: "deletea",
  d: "M2171.419,718.654a.637.637,0,0,0,.637-.637v-6.862a.637.637,0,0,0-1.273,0v6.862A.636.636,0,0,0,2171.419,718.654Z",
  transform: "translate(-39.089 -23.457)"
}));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.594,
    height: 17.823,
    viewBox: "0 0 16.594 17.823",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.9f6fc38c.svg";
export { ForwardRef as ReactComponent };